<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_ix">Note on Previously Published Material</a></p><a id="page_ix">
<p class="noindent"><span class="small">PARTS OF CHAPTER 2 PREVIOUSLY APPEARED IN SPANISH IN</span> “Re-configurando Comunidades: Judíos Sefaradíes/Árabes in Argentina, 1900–1950,” in <i>Arabes y judíos en Iberoamérica: similitudes, diferencias y tensiones</i> (Madrid: Dykinson, 2008). Sections of chapter 4 and chapter 5 appeared previously in “Electing ‘Miss Sefaradí’, and ‘Queen Esther’: Sephardim, Zionism, and Ethnic and National Identities in Argentina, 1933–1971,” in <i>The New Jewish Argentina: Facets of Jewish Experiences in the Southern Cone</i>, edited by Adriana Brodsky and Raanan Rein (Leiden: Brill, 2012). Sections of chapter 6 appeared previously in “Educating Argentine Jews: Sephardim and Their Schools, 1920s–1960s,” in <i>Returning to Babel: Jewish Latin American Experiences and Representations</i>, edited by Amalia Ran and Jean Cahan (Leiden: Brill, 2011).</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm03.vue?aa0cc752